module.exports = __webpack_public_path__ + "bcd6b25d3f71176db7a8383e435a7cfb.svg";